import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { useTranslation } from "react-i18next";

export function NetworkStatusBanner() {
  const { isOnline } = useNetworkStatus();
  const { t } = useTranslation('layout');

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-destructive text-destructive-foreground text-center py-2 z-50 text-sm font-medium">
      <WifiOff className="inline w-4 h-4 mr-2" />
      {t('networkStatus.offlineWarning')}
    </div>
  );
}
